import React from "react";
import { FieldProps, getIn } from "formik";
import { TextFieldProps, TextField } from "@mui/material";
import { defaultTo } from "lodash";

export const FormTextField: React.FC<FieldProps & TextFieldProps> = (props) => {
  const isTouched = getIn(props.form.touched, props.field.name);
  const errorMessage = getIn(props.form.errors, props.field.name);

  const { error, helperText, field, ...rest } = props;

  field.value = defaultTo(field.value, "");

  return (
    <TextField
      variant="outlined"
      error={error ?? Boolean(isTouched && errorMessage)}
      helperText={
        helperText ?? (isTouched && errorMessage ? errorMessage : undefined)
      }
      margin="normal"
      {...rest}
      {...field}
    />
  );
};
